const Buttons = {
  baseStyle: {},
  variants: {
    mdlClose: {
      color: "white",
      bg: "Accent.500",
      _hover: {
        color: "black",
        bg: "Accent.100",
      },
    },
    primary: {
      color: "white",
      borderRadius: "lg",
      bg: "Primary.500",
      _hover: {
        bg: "Primary.600",
        color: "white",
        _disabled: {
          bg: "Gray.400",
          opacity: 1,
        },
      },
      _disabled: {
        bg: "Gray.400",
        opacity: 1,
      },
    },
    primaryResponsive: {
      p: [3.5, 4, 5, 5, 6],
      fontSize: ["sm", "md", "lg", "xl", "xl"],
      minWidth: "fit-content",
      minHeight: "fit-content",
      color: "white",
      borderRadius: "lg",
      bg: "Primary.500",
      _hover: {
        bg: "Primary.600",
        color: "white",
        _disabled: {
          bg: "Gray.400",
          opacity: 1,
        },
      },
      _disabled: {
        bg: "Gray.400",
        opacity: 1,
      },
    },
    MicroPrimaryResponsive: {
      p: [2.5, 3, 3.5, 4, 4],
      fontSize: ["xs", "xs", "sm", "md", "lg"],
      color: "white",
      borderRadius: "lg",
      bg: "Primary.500",
      minWidth: "fit-content",
      minHeight: "fit-content",
      _hover: {
        bg: "Primary.600",
        color: "white",
        _disabled: {
          bg: "Gray.400",
          opacity: 1,
        },
      },
      _disabled: {
        bg: "Gray.400",
        opacity: 1,
      },
    },
    secondary: {
      color: "white",
      borderRadius: "lg",
      bg: "Secondary.500",
      _hover: {
        bg: "Secondary.600",
        color: "white",
        _disabled: {
          bg: "Gray.400",
          color: "white",
        },
      },
      _disabled: {
        bg: "Gray.400",
        color: "white",
      },
    },
    grayRounded: {
      color: "white",
      borderRadius: "full",
      bg: "Gray.500",
      _hover: {
        bg: "Gray.600",
        color: "white",
      },
    },
    outline: {
      color: "white",
      border: "1px",
      borderColor: "white",
      bg: "none",
      _hover: {
        bg: "Primary.700",
        color: "white",
      },
    },
    standardSqr: {
      color: "white",
      bg: "Secondary.500",
      _hover: {
        bg: "Secondary.700",
        color: "white",
        _disabled: {
          bg: "Gray.400",
          color: "Gray.600",
        },
      },
      _disabled: {
        bg: "Gray.400",
        color: "Gray.600",
      },
    },
    link: {
      p: 2,
      color: "white",
      bg: "transparent",
      borderRadius: "none",
      boxShadow: "none",
      display: "flex",
      justifyContent: "flex-start",
      fontSize: "xl",
      fontWeight: 100,
      _hover: {
        bg: "transparent",
      },
    },
    table: {
      fontSize: "sm",
      color: "Primary.500",
      bg: "Gray.100",
      _hover: {
        bg: "Secondary.50",
      },
    },
    filter: {
      borderRadius: "full",
      h: 8,
      width: "fit-content",
      px: 1.5,
      fontSize: "sm",
      color: "white",
      bg: "Primary.500",
      _hover: {
        bg: "Primary.700",
        color: "white",
      },
    },
    account: {
      color: "Accent.700",
      bg: "Gray.100",
      borderRadius: "2xl",
      width: "100%",
      h: 12,
      _hover: {
        bg: "Gray.200",
      },
    },
  },
}

export default Buttons
